/* eslint-disable no-unused-vars */
import { Fragment, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { LI, UL } from "../../AbstractElements";
import { Label } from "reactstrap";
import { Back } from "../../Constant";
import { useCustomContext } from "../../_helper/customizer";
import { useMenuItems } from "./Menu";

function normalizeMenuPath(p) {
  if (!p || p === "#") return "";
  const s = String(p).replace(/\/+$/, "") || "/";
  return s;
}

function pathnameMatchesMenuPath(pathnameNorm, menuPathNorm) {
  if (!menuPathNorm) return false;
  return (
    pathnameNorm === menuPathNorm ||
    pathnameNorm.startsWith(`${menuPathNorm}/`)
  );
}

function walkMenuLinks(sections, visit) {
  if (!sections) return;
  for (const section of sections) {
    if (!section.Items) continue;
    for (const item of section.Items) {
      visit(item);
      if (item.children) {
        for (const c of item.children) {
          visit(c);
          if (c.children) {
            for (const d of c.children) {
              visit(d);
            }
          }
        }
      }
    }
  }
}

function getLongestActiveMenuPath(pathname, menuSections) {
  const loc = normalizeMenuPath(pathname);
  let best = "";
  walkMenuLinks(menuSections, (item) => {
    if (item.type !== "link" || !item.path) return;
    const p = normalizeMenuPath(item.path);
    if (!p) return;
    if (pathnameMatchesMenuPath(loc, p) && p.length > best.length) {
      best = p;
    }
  });
  return best;
}

function subtreeContainsActiveRoute(item, pathname) {
  const loc = normalizeMenuPath(pathname);
  if (item.type === "link" && item.path) {
    const p = normalizeMenuPath(item.path);
    if (p && pathnameMatchesMenuPath(loc, p)) return true;
  }
  if (item.children) {
    return item.children.some((c) => subtreeContainsActiveRoute(c, pathname));
  }
  return false;
}

/** Open submenus that contain the current route (navigation / refresh). Collapse is user-controlled. */
function expandSubsContainingPath(item, pathname) {
  if (!item.children) return;
  for (const c of item.children) {
    expandSubsContainingPath(c, pathname);
  }
  if (subtreeContainsActiveRoute(item, pathname)) {
    item.active = true;
  }
}

const EMPTY_PLATFORM_MENU = [];

const SidebarMenuItems = ({ sidebartoogle }) => {
  const { platform } = useCustomContext();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [, setAccordionBump] = useState(0);
  const isRtl = i18n.language === "ae";
  const angleExpandClass = isRtl ? "fa-angle-left" : "fa-angle-right";
  const platformMenuItems = useMenuItems();
  const MENUITEMS = platformMenuItems[platform] ?? EMPTY_PLATFORM_MENU;

  const activeMenuPath = useMemo(
    () => getLongestActiveMenuPath(location.pathname, MENUITEMS),
    [location.pathname, MENUITEMS]
  );

  useEffect(() => {
    const path = location.pathname;
    MENUITEMS.forEach((section) => {
      section.Items?.forEach((item) => {
        expandSubsContainingPath(item, path);
      });
    });
    setAccordionBump((n) => n + 1);
  }, [location.pathname, MENUITEMS]);

  const isLinkActive = (path) =>
    !!path && normalizeMenuPath(path) === activeMenuPath;

  const bumpAfterAccordionToggle = () =>
    setAccordionBump((n) => n + 1);

  const toggletNavActive = (item) => {
    if (window.innerWidth <= 991) {
      const pageHeader = document.querySelector(".page-header");
      const sidebarWrapper = document.querySelector(".sidebar-wrapper");
      if (pageHeader && sidebarWrapper) {
        pageHeader.className = "page-header close_icon";
        sidebarWrapper.className = "sidebar-wrapper close_icon ";
        if (item.type === "sub") {
          pageHeader.className = "page-header ";
          sidebarWrapper.className = "sidebar-wrapper ";
        }
      }
    }

    if (item.children) {
      item.active = !item.active;
    }
    bumpAfterAccordionToggle();
  };

  const onLeafLinkClick = () => {
    if (window.innerWidth <= 991) {
      const pageHeader = document.querySelector(".page-header");
      const sidebarWrapper = document.querySelector(".sidebar-wrapper");
      if (pageHeader && sidebarWrapper) {
        pageHeader.className = "page-header close_icon";
        sidebarWrapper.className = "sidebar-wrapper close_icon ";
      }
    }
  };

  return (
    <Fragment>
      <UL

        attrUL={{
          style: {
            height: "100%",
          },
          className: "custom-scrollbar simple-list sidebar-links mt-1",
          id: "simple-bar",
        }}
      >
        <div className="simplebar-wrapper" style={{ margin: "0px" }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div
              className="simplebar-offset"
              style={{ right: "0px", bottom: "0px" }}
            >
              <div
                className="simplebar-content-wrapper"
                style={{ height: "100%" }}
              >
                <div className="simplebar-content">
                  <LI attrLI={{ className: "back-btn" }}>
                    <div className="mobile-back text-end">
                      <span>{Back}</span>
                      <i className={`fa ${angleExpandClass} ps-2`}></i>
                    </div>
                  </LI>
                  {MENUITEMS.map((Item, i) => (
                    <Fragment key={i}>
                      {Item.Items.map((menuItem, i) => (
                        <LI attrLI={{ className: "sidebar-list" }} key={i}>
                          {menuItem.type === "sub" && (
                            <Fragment>
                              <a
                                href="javascript"
                                className={`sidebar-link sidebar-title${
                                  menuItem.active ? " active" : ""
                                }${
                                  !menuItem.active &&
                                  subtreeContainsActiveRoute(
                                    menuItem,
                                    location.pathname
                                  )
                                    ? " sidebar-contains-route"
                                    : ""
                                }`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  toggletNavActive(menuItem);
                                }}
                              >
                                {menuItem.icon !== undefined && (
                                  <menuItem.icon />
                                )}
                                <span>{t(menuItem.title)}</span>
                                <div className="according-menu">
                                  {menuItem.active ? (
                                    <i className="fa fa-angle-down"></i>
                                  ) : (
                                    <i className={`fa ${angleExpandClass}`}></i>
                                  )}
                                </div>
                              </a>
                            </Fragment>
                          )}
                          {menuItem.type === "link" && (
                            <>
                              {menuItem.badge2 && (
                                <Label className="badge badge-light-danger">
                                  Latest
                                </Label>
                              )}
                              <Link
                                to={menuItem.path}
                                className={`sidebar-link sidebar-title ${
                                  isLinkActive(menuItem.path) ? "active" : ""
                                }`}
                                onClick={onLeafLinkClick}
                              >
                                {menuItem.icon !== undefined && (
                                  <menuItem.icon />
                                )}
                                <span>{t(menuItem.title)}</span>
                              </Link>
                            </>
                          )}
                          {menuItem.children && (
                            <UL
                              attrUL={{
                                className: "simple-list sidebar-submenu",
                                style: menuItem.active
                                  ? sidebartoogle
                                    ? {
                                        opacity: 1,
                                        transition: "opacity 500ms ease-in",
                                      }
                                    : { display: "block" }
                                  : { display: "none" },
                              }}
                            >
                              {menuItem.children.map((childrenItem, index) => {
                                return (
                                  <LI key={index}>
                                    {childrenItem.type === "sub" && (
                                      <a
                                        href="javascript"
                                        className={`${
                                          childrenItem.active ||
                                          subtreeContainsActiveRoute(
                                            childrenItem,
                                            location.pathname
                                          )
                                            ? "active"
                                            : ""
                                        } ${
                                          childrenItem.icon
                                            ? "has-icon flex items-center gap-2"
                                            : "no-icon"
                                        }`}
                                        onClick={(event) => {
                                          event.preventDefault();
                                          toggletNavActive(childrenItem);
                                        }}
                                      >
                                        {childrenItem.icon !== undefined && (
                                          <childrenItem.icon />
                                        )}
                                        <span>{t(childrenItem.title)}</span>
                                        <div className="according-menu">
                                          {childrenItem.active ? (
                                            <i className="fa fa-angle-down"></i>
                                          ) : (
                                            <i className={`fa ${angleExpandClass}`}></i>
                                          )}{" "}
                                        </div>
                                      </a>
                                    )}
                                    {childrenItem.type === "link" && (
                                      <Link
                                        to={childrenItem.path}
                                        className={`${
                                          isLinkActive(childrenItem.path)
                                            ? "active"
                                            : ""
                                        } ${
                                          childrenItem.icon
                                            ? "has-icon flex items-center gap-2"
                                            : "no-icon"
                                        }`}
                                        onClick={onLeafLinkClick}
                                      >
                                        {childrenItem.icon !== undefined && (
                                          <childrenItem.icon />
                                        )}
                                        <span>{t(childrenItem.title)}</span>
                                      </Link>
                                    )}
                                    {childrenItem.children && (
                                      <UL
                                        attrUL={{
                                          className:
                                            "simple-list nav-sub-childmenu submenu-content",
                                          style: childrenItem.active
                                            ? { display: "block" }
                                            : { display: "none" },
                                        }}
                                      >
                                        {childrenItem.children.map(
                                          (childrenSubItem, key) => (
                                            <LI key={key}>
                                              {childrenSubItem.type ===
                                                "link" && (
                                                  <Link
                                                    to={childrenSubItem.path}
                                                    className={`${
                                                      isLinkActive(
                                                        childrenSubItem.path
                                                      )
                                                        ? "active"
                                                        : ""
                                                    } ${
                                                      childrenSubItem.icon
                                                        ? "has-icon flex items-center gap-2"
                                                        : "no-icon"
                                                    }`}
                                                    onClick={onLeafLinkClick}
                                                  >
                                                    {childrenSubItem.icon !==
                                                      undefined && (
                                                        <childrenSubItem.icon />
                                                      )}
                                                    <span>{t(childrenSubItem.title)}</span>
                                                  </Link>
                                                )}
                                            </LI>
                                          )
                                        )}
                                      </UL>
                                    )}
                                  </LI>
                                );
                              })}
                            </UL>
                          )}
                        </LI>
                      ))}
                    </Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="simplebar-track simplebar-horizontal"
          style={{ visibility: "hidden" }}
        >
          <div
            className="simplebar-scrollbar"
            style={{ width: "0px", display: "none" }}
          ></div>
        </div>
        <div
          className="simplebar-track simplebar-vertical"
          style={{ visibility: "visible" }}
        >
          <div className="simplebar-scrollbar"></div>
        </div>
      </UL>
    </Fragment>
  );
};
export default SidebarMenuItems;
